export type ModerationFilter = "all" | "safety" | "pending" | "published_review";

export type ModerationCountKey = "all" | "safety" | "pending" | "publishedReview";

export interface ModerationFilterDefinition {
  id: ModerationFilter;
  label: string;
  title: string;
  description: string;
  countKey: ModerationCountKey;
}

export const MODERATION_FILTERS: ReadonlyArray<ModerationFilterDefinition> = [
  {
    id: "all",
    label: "Alla aktiva",
    title: "Alla aktiva granskningsärenden",
    description:
      "Säkerhetsavvikelser visas först, följt av automatiskt avslagna, väntande och publicerade stickprov.",
    countKey: "all",
  },
  {
    id: "safety",
    label: "Akut säkerhet",
    title: "Publicerade utan godkänd säkerhetsgranskning",
    description:
      "Dessa recept är redan synliga men har underkänd eller saknad verifiering. Granska dem omgående.",
    countKey: "safety",
  },
  {
    id: "pending",
    label: "Väntar på beslut",
    title: "Recept som väntar på administrativ granskning",
    description:
      "Dessa recept är inte publicerade. Kön omfattar inskickade, AI-kontrollerade, utkast och automatiskt avslagna communityrecept som ännu saknar administrativt beslut.",
    countKey: "pending",
  },
  {
    id: "published_review",
    label: "Publicerade stickprov",
    title: "Publicerade recept för stickprov",
    description:
      "AI-kontrollerade communityrecept som är publicerade men ännu inte manuellt stickprovsgranskade.",
    countKey: "publishedReview",
  },
];

export function resolveModerationFilter(value: string | null): ModerationFilter {
  return MODERATION_FILTERS.some((item) => item.id === value) ? (value as ModerationFilter) : "all";
}

export function resolveModerationRecipeId(value: string | null): string | null {
  if (!value) return null;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
    ? value.toLowerCase()
    : null;
}

export function moderationQueueApiPath(
  filter: ModerationFilter,
  recipeId: string | null = null,
): string {
  const query = new URLSearchParams({ filter });
  if (recipeId) query.set("recipe", recipeId);
  return `/admin/v1/moderation/recipes?${query.toString()}`;
}

export function moderationBrowserParams(filter: ModerationFilter): Record<string, string> {
  return filter === "all" ? {} : { filter };
}
